export const getPersonStructuredData = () => ({
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Stavros Symeonidis",
    "url": "https://www.stavrossymeonidis.dev",
    "image": "https://www.stavrossymeonidis.dev/graph-profile-dev.jpg",
    "sameAs": [
      "https://www.linkedin.com/in/stav-symeonidis/",
      "https://github.com/techaras"
    ],
    "jobTitle": "Senior Software Engineer",
    "worksFor": {
      "@type": "Organization",
      "name": "Independent Consultant"
    },
    "description": "Senior software engineer running a UK data-engineering practice for DTC, CPG, and healthcare brands",
    "alumniOf": {
      "@type": "EducationalOrganization",
      "name": "AI Forge"
    },
    "award": [
      "AI Patent Winner 2023 - IP Hatch",
      "AI Forge Cohort 5 Alumnus",
      "Sky Labs Finalist 2022"
    ],
    "knowsAbout": [
      "Multi-Touch Attribution",
      "Contribution Margin Analytics",
      "Data Engineering",
      "NetSuite Integration",
      "Celigo",
      "EDI Integration",
      "LLM Workflow Automation"
    ]
  });
  
  export const getWebSiteStructuredData = () => ({
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Stavros Symeonidis Portfolio",
    "url": "https://www.stavrossymeonidis.dev",
    "description": "Portfolio of Stavros Symeonidis - senior software engineer and data-engineering practice",
    "publisher": {
      "@type": "Person",
      "name": "Stavros Symeonidis"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.stavrossymeonidis.dev/?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  });
  
  export const getServiceStructuredData = () => ({
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Data Engineering",
    "provider": {
      "@type": "Person",
      "name": "Stavros Symeonidis"
    },
    "areaServed": {
      "@type": "Place",
      "name": "Global"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Data Engineering Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "LLM Workflow Automation",
            "description": "Document processing, intake automation, and structured extraction over your data"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "NetSuite, Celigo & EDI Integration",
            "description": "Connect Shopify, Stripe, and Recharge to NetSuite with custom EDI and 3PL routing"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Multi-Touch Attribution",
            "description": "Markov, Shapley, and blended attribution with revenue feedback to Google Ads and Meta"
          }
        },
        {
            "@type": "Offer", 
            "itemOffered": {
                "@type": "Service",
                "name": "Contribution Margin Engineering",
                "description": "Blend ad spend, 3PL costs, and processor fees so CAC, payback, and margin stay accurate"
            }
        }
      ]
    }
  });
  
  export const getCaseStudyStructuredData = (caseStudy: {
    title: string;
    description: string;
    image: string;
    url: string;
    datePublished: string;
  }) => ({
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": caseStudy.title,
    "description": caseStudy.description,
    "image": caseStudy.image,
    "url": caseStudy.url,
    "datePublished": caseStudy.datePublished,
    "author": {
      "@type": "Person",
      "name": "Stavros Symeonidis"
    },
    "publisher": {
      "@type": "Person",
      "name": "Stavros Symeonidis"
    }
  });